import React from "react";
import styles from "../../static/css/pages.module.css";
import Title from "../../components/title/title";
import Button from "../../components/form/button/button";
import Dropdown from "../../components/form/dropdown/dropdown";
import Header from "../../components/header/priv/header";
import Footer from "../../components/footer/footer";
import ScrollTo from "../../components/scrolltop/scrollto";
import PageSuccess from "./success";
import Datepicker from "../../components/form/datepicker/datepicker";
import PageError from "./error";
import InputDiv from "../../components/form/input/input_div";
import {postDataAction} from "../../store/actions/postDataAction";
import {connect} from "react-redux";
import * as consts from "../../store/constants/userInfo";
import PageLoading from "../server/preload";
import Checkbox from "../../components/form/checkbox/checkbox";
import axios from "axios";
import parse from 'html-react-parser';

class FormRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activities: '',
      region: '',
      agree: false
    }
  }

  componentDidMount() {
    axios.get(process.env.REACT_APP_GATE + 'partner/agreement', {responseType: 'blob'})
        .then(response => {
          const header = response.headers["content-disposition"].replace(new RegExp('"', 'g'), '').split('filename=');
          let fileName = header.length > 1 ? header[1] : 'Rules';
          let link = document.getElementById('downloadFile');
          if (window.navigator.msSaveOrOpenBlob) {
            link.addEventListener('click', () => {
              return window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName);
            })
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', fileName);
            link.href = url;
          }
        })
        .catch(error => console.error(error))
  }

  handleSelect = (e, params) => {
    let newState = params.name;
    let newValue = e.value;
    this.setState({
      [newState]: newValue
    })
  }

  handleMultiSelect = (e, params) => {
    let newState = params.name;
    let str = '';
    if (e) {
      e.forEach(function (el) {
        str += el.value + ',';
      });
    }
    let newstr = str.substring(0, str.length - 1);
    let newValue = JSON.parse("[" + newstr + "]");
    this.setState({
      [newState]: newValue
    })
  }

  handleState = (e) => {
    const name = e.target.name;
    const value = e.target.getAttribute("value");
    this.setState({
      [name]: value,
    })
  }

  handleSubmit = (e) => {
    let formData;
    formData = {
      region: this.state.region
    }
    if (this.state.activities?.length) formData.activities = this.state.activities;
    this.props.fetchData(process.env.REACT_APP_GATE + "client/registration/", this, consts.CLIENT_REGISTRATION_POST, formData, e.target);
  }

  render() {
    const agreementLabel = '<div>Я принимаю условия <a id="downloadFile">Пользовательского соглашения</a></div>'
    if (this.props.data.items) {
      switch (this.props.data.items.result.status) {
        case "ERROR":
          return <PageError
            infoTitle="Что-то пошло не так"
            infoMessage={this.props.data.items.result.errorMessage}
            infoLink={process.env.REACT_APP_ELF_URL}
            infoButton="Вернуться в интернет-банк"
          />;
        case "TIMEOUT":
          return <PageError
            infoTitle="Что-то пошло не так"
            infoMessage="Сервис временно недоступен, повторите операцию позже."
            infoLink={process.env.REACT_APP_ELF_URL}
            infoButton="Вернуться в интернет-банк"
          />;
        case "SUCCESS":
          return <PageSuccess
            infoTitle="Заявление успешно отправлено"
            infoMessage={<div>Ваши данные направлены в Федеральную налоговую службу для регистрации статуса самозанятого.<br />
              Как только статус будет подтверждён, вы получите доступ к личному кабинету.</div>}
            infoButton="Вернуться в Интернет банк"
            infoLink={process.env.REACT_APP_ELF_URL}
            reloadButton="Проверить статус"
          />;
        default:
          return <PageLoading />;
      }
    }
    else {
      return <main>
        <Header/>
        <section className={styles.section}>
          <div className="inner">
            <div className="l-grid">
              <div className="l-grid__item_8 mobile_l-grid__item_12">
                <div className={styles.content}>
                  <div className="l-grid_pt-8 mobile_l-grid">
                    <div className="l-grid__item_1"/>
                    <div className="l-grid__item_6 mobile_l-grid__item_10" data-form>
                      <Title icon="icon_org" title="Стать самозанятым"/>
                      <div className={styles.article}>
                        <div className="l-grid_pt-6">
                          {this.props.registerData?.inn?
                            <React.Fragment>
                              <div className="l-grid__item_2">
                                <InputDiv label="ИНН" value={this.props.registerData.inn} name="inn"/>
                              </div>
                              <div className="l-grid__item_4"/>
                            </React.Fragment>
                            :
                            null
                          }
                          {this.props.registerData?.passportNumber && this.props.registerData?.passportSeries?
                            <React.Fragment>
                              <div className="l-grid__item_1 l-grid__item_passport">
                                <InputDiv label="Паспорт" value={this.props.registerData.passportSeries} name="passportSeries" required="true" disabled/>
                              </div>
                              <div className="l-grid__item_2 l-grid__item_passport">
                                <InputDiv label="&nbsp;" value={this.props.registerData.passportNumber} name="passportNumber" required="true" disabled/>
                              </div>
                            </React.Fragment>
                            :
                            null
                          }
                          <div className="l-grid__item_6">
                            <InputDiv label="Фамилия" value={this.props.registerData.surname} name="surname" required="true"
                                      disabled/>
                          </div>
                          <div className="l-grid__item_3">
                            <InputDiv label="Имя" value={this.props.registerData.name} name="name" required="true" disabled/>
                          </div>
                          <div className="l-grid__item_3">
                            <InputDiv label="Отчество" value={this.props.registerData.secondName} name="secondName"
                                      required="true" disabled/>
                          </div>
                          <div className="l-grid__item_3">
                            <Datepicker label="Дата рождения" value={this.props.registerData.birthday} disabled
                                        name="birthday"/>
                          </div>
                          <div className="l-grid__item_3">
                            <InputDiv label="Номер мобильного телефона"
                                      required="true" value={this.props.registerData.phoneNumber} name="phoneNumber"
                                      onChange={this.handleState} error="Неверный формат поля" disabled/>
                          </div>
                          <div className="l-grid__item_6">
                            <Dropdown label="Виды деятельности"
                                      placeholder="Выберите одно или несколько значений"
                                      isMulti="true" items={this.props.registerData.activities}
                                      name="activities" onChange={this.handleMultiSelect}/>
                            <Dropdown label="Регион преимущественного ведения деятельности"
                                      placeholder="Выберите регион"
                                      required items={this.props.registerData.regions} name="region"
                                      onChange={this.handleSelect}/>
                            <div>
                              <Checkbox
                                  items={{data:
                                        [{id: 'agree',
                                          name: 'agree',
                                          label: parse(agreementLabel),
                                          required: true,
                                          value: this.state.agree
                                          }]
                                        }}
                                  onChange={() => this.setState({agree: !this.state.agree})}
                              />
                            </div>
                            <div className="text_underinput">
                              Нажимая «Пройти регистрацию», Вы соглашаетесь на постановку на учёт в налоговом органе
                              в качестве налогоплательщика «Налога на профессиональный доход» и уполномочиваете банк
                              на реализацию прав и исполнение обязанностей установленных Федеральным Законом
                              от 27.11.2018 г. № 422-ФЗ «О проведении эксперимента по установлению специального
                              налогового режима «Налог на профессиональный доход»
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="l-align_right">
                        <Button title="Пройти регистрацию" onClick={this.handleSubmit} disabled={!this.state.agree}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer/>
        <ScrollTo position="0"/>
      </main>
    }
  }
}

const mapStateToProps = state => ({data: state.clientRegistrationPost})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types, body, el) => dispatch(postDataAction(url, parent, types, body, el))}
}

export default connect(mapStateToProps, mapDispatchToProps)(FormRegister);
